<template>
    <div class="setting-form-wrap" :class="{'limit-height': isFocus}">
        <div class="setting-form-item">
            <div class="setting-form-item-label">
                公司名称：
                <span class="is-required">*</span>
            </div>
            <div class="setting-form-item-content">
                <input
                    v-model="formData.comName"
                    placeholder="请输入您的商号或公司全称"
                    :class="{'input-error': !!errorObj.comName}"
                    @focus="onChangeFocus(true)"
                    @blur="onChangeFocus(false)"
                />
                <p v-show="errorObj.comName" class="error-text">{{ errorObj.comName }}</p>
            </div>
        </div>
        <div class="setting-form-item">
            <div class="setting-form-item-label">
                注册地区：
                <span class="is-required">*</span>
            </div>
            <el-select
                v-model="formData.regionCode"
                size="large"
                @change="onRegionChange"
            >
                <el-option-group
                    v-for="group in regionDatasource"
                    :key="group.label"
                    :label="group.label"
                >
                    <el-option
                        v-for="item in group.options"
                        class="cbs-city-select-option"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                        <span>{{ item.label }}</span>
                        <span v-if="item.isSpecialCity" class="hui-icon"></span>
                    </el-option>
                </el-option-group>
            </el-select>
        </div>
        <div class="setting-form-item">
            <div class="setting-form-item-label">
                纳税人类型：
                <span class="is-required">*</span>
            </div>
            <div class="setting-form-item-content wrap-margin setting-checkbox-wrap">
                <button
                    v-for="(item, index) in taxpayerTypeDataSource"
                    :key="index"
                    :class="{active: formData.taxpayerType === item.value}"
                    @click="onSelect('taxpayerType', item.value)"
                >{{ item.label }}</button>
            </div>
        </div>
        <div class="setting-form-item">
            <div class="setting-form-item-label">
                公司性质：
                <span class="is-required">*</span>
            </div>
            <div class="setting-form-item-content wrap-margin setting-checkbox-wrap">
                <button
                    v-for="(item, index) in companyDataSource"
                    :key="index"
                    :class="{active: formData.companyType === item.value}"
                    @click="onSelect('companyType', item.value)"
                >{{ item.label }}</button>
            </div>
        </div>
        <div class="setting-form-item">
            <div class="setting-form-item-label">
                服务套餐：
                <span class="is-required">*</span>
            </div>
            <div class="setting-form-item-content wrap-margin setting-checkbox-wrap">
                <button
                    v-for="(item, index) in serviceTypeDataSource"
                    :key="index"
                    :class="{active: formData.serviceType === item.value}"
                    @click="onSelect('serviceType', item.value)"
                >{{ item.content }}</button>
            </div>
        </div>
        <div class="setting-form-item">
            <div class="setting-form-item-label">
                经营范围：
                <span class="is-required">*</span>
            </div>
            <div class="setting-form-item-content">
                <el-select
                    v-model="formData.bizScope"
                    size="large"
                >
                    <el-option
                        v-for="(item, index) in companyScopeList"
                        :key="index"
                        :label="item.type"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </div>
        </div>
        <div class="setting-form-item">
            <div class="setting-form-item-label">备注：</div>
            <div class="setting-form-item-content">
                <input v-model="formData.description" placeholder="请输入您的内容"/>
            </div>
        </div>
        <div class="setting-form-item">
            <div class="setting-form-item-label">
                联系电话：
                <span class="is-required">*</span>
            </div>
            <div class="setting-form-item-content">
                <input
                    v-model="formData.phone"
                    placeholder="请输入电话信息"
                    type="number"
                    :class="{'input-error': !!errorObj.phone}"
                />
                <p v-show="errorObj.phone" class="error-text">{{ errorObj.phone }}</p>
            </div>
        </div>
        <div class="setting-form-item">
            <div class="setting-form-item-label">
                验证码：
                <span class="is-required">*</span>
            </div>
            <div class="setting-form-item-content">
                <div class="setting-sms-code">
                    <input
                        v-model="formData.smsCode"
                        placeholder="请输入验证码"
                        type="number"
                        :class="{'input-error': !!errorObj.smsCode}"
                    />
                    <button
                        class="send-code-btn"
                        @click="getVerifyCode"
                    >{{ codeCountDown === 60 ? '发送验证码' : `${codeCountDown}s` }}</button>
                </div>
                <p v-show="errorObj.smsCode" class="error-text">{{ errorObj.smsCode }}</p>
            </div>
        </div>
    </div>
</template>

<script>

import {
    taxpayerTypeDataSource,
    companyDataSource,
    serviceTypeDataSource,
    companyScopeList,
    packageTypeDataSource
} from '../../pages/data/cbs';
import {formDataValidConfig} from '../../pages/data/global';
import client from '../../common/client';
import {regionMixin, crsDetailMixin, sendCodeMixin} from './mixin';

export default {
    mixins: [regionMixin, crsDetailMixin, sendCodeMixin],

    data() {
        return {
            formData: {
                comName: '',
                serviceType: 'COMPANY_REGISTRATION',
                regionCode: 110100,
                taxpayerType: '小规模纳税人',
                companyType: '有限公司',
                bizScope: '文化传媒类',
                description: '',
                phone: '',
                smsCode: ''
            },
            taxpayerTypeDataSource,
            companyDataSource,
            serviceTypeDataSource,
            companyScopeList,
            companyRegionDatasource: [],
            packageRegionDatasource: [],
            comRegDisableArea: [],
            errorObj: {},
            isFocus: false
        };
    },

    async created() {
        await this.getRegion();
        const {consultCities, pkgCityGroups, comRegDisableArea, comRegPreferentialCities} = this.staticRegionData;
        this.companyRegionDatasource = this.convertRegionDataToGroupData(consultCities, comRegPreferentialCities);
        this.packageRegionDatasource = this.convertRegionDataToGroupData(pkgCityGroups, comRegPreferentialCities);
        this.comRegDisableArea = comRegDisableArea;
        this.setRegionDatasource();
        this.getUrlParam();
        this.onRegionChange();
    },

    methods: {
        validorFormData(list = ['comName', 'phone', 'smsCode']) {
            let isPass = true;
            list.map(key => {
                const value = this.formData[key];
                this.$set(this.errorObj, key, formDataValidConfig[key](value) || '');
                if (this.errorObj[key]) {
                    isPass = false;
                }
            });
            return isPass;
        },

        getVerifyCode() {
            if (!this.validorFormData(['phone'])) {
                return;
            }
            this.getVerifyCodeMixin(this.formData.phone);
        },

        getFormData() {
            if (!this.validorFormData()) {
                return Promise.reject();
            }
            const {
                phone, smsCode, comName, regionCode, bizScope,
                description, taxpayerType, companyType, serviceType
            } = this.formData;
            return client.validCbsVerifyCode({
                phone, smsCode
            })
            .then(res => {
                if (res.data && res.data.success === false) {
                    this.$set(this.errorObj, 'smsCode', '验证码错误');
                    return Promise.reject();
                }
                this.$set(this.errorObj, 'smsCode', '');
                return {
                    comName,
                    area: regionCode,
                    taxpayerType: this.getValueByLabel(
                            taxpayerTypeDataSource,
                            taxpayerType,
                            '_value'
                        ),
                    comType: this.getValueByLabel(companyDataSource, companyType, '_value'),
                    packageType: packageTypeDataSource[serviceType],
                    bizScope,
                    description,
                    phone,
                    stepStart: 3
                };
            });
        },

        getValueByLabel(datasource, label, valueKey = 'value', labelKey = 'label') {
            for (let i = 0; i < datasource.length; i++) {
                if (datasource[i][labelKey] === label) {
                    return datasource[i][valueKey];
                }
            }
            return '';
        },

        onChangeFocus(value) {
            setTimeout(() => {
                this.isFocus = value;
            });
        }
    }
};
</script>

<style lang="less" scoped>
.send-code-btn {
    width: 20rem;
    height: 6.8rem;
    background: #2a62fe;
    border-radius: 0.4rem;
    font-family: PingFangSC-Regular;
    font-size: 2.6rem;
    color: #fff;
    letter-spacing: 0;
    font-weight: 400;
    border: none;
    outline: none;
    white-space: nowrap;
}

.limit-height {
    max-height: 40rem;
}

.cbs-city-select-option {
    .hui-icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-left: 10px;
        background: url(../../assets/city-icon-hui.png) no-repeat;
        background-size: contain;
        vertical-align: middle;
    }
}
</style>